import { t } from '@lingui/core/macro';
import { NoddiButton } from 'noddi-ui-web';

type Props = {
  /** Rendered above the buttons rather than in the scroll area, so a refusal is visible wherever the body is scrolled. */
  errorContent?: React.ReactNode;
  /** Any request in flight — snoozing and the primary action both wait, so nothing lands half applied. */
  isBusy: boolean;
  onSkip: () => void;
  primaryAction: React.ReactNode;
};

export const ConfirmPromptFooter = ({ errorContent, isBusy, onSkip, primaryAction }: Props) => (
  <div className='flex flex-col gap-3 pt-4'>
    {errorContent}
    <div className='flex items-center justify-between gap-2'>
      <NoddiButton variant='ghost' className='-ml-4' disabled={isBusy} onClick={onSkip}>
        {t`Remind me later`}
      </NoddiButton>
      {primaryAction}
    </div>
  </div>
);
